/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_MissingInputs */



/**
* | output |
* | --- |
* | "No video file selected" |
*
* @param {Audio_Description_Export_Video_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_missing = /** @type {((inputs?: Audio_Description_Export_Video_MissingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_MissingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun fichier vidéo sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Videodatei ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun file video selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофайл не выбран")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún archivo de vídeo seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイルが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई वीडियो फ़ाइल चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum arquivo de vídeo selecionado")
	return /** @type {LocalizedString} */ ("No video file selected")
});